import moment from 'moment';

export const currentProjectDiaryEntries = (state) => {
  return state.currentProjectDiaryEntries;
};

export const currentProjectMissingDiaryEntries = (state) => {
  let diaryMissingDateList = [];

  let diaryStartDate = state.currentProject.projectStartdate;
  if (state.currentProject.diaryStartDate) {
    diaryStartDate = state.currentProject.diaryStartDate;
  }

  let diaryEndDate = state.currentProject.projectEnddate;
  if (moment().isBefore(diaryEndDate)) {
    diaryEndDate = moment().format('YYYY-MM-DD');
  }

  var start = moment(diaryStartDate, 'YYYY-MM-DD');
  var end = moment(diaryEndDate);

  // Difference in number of days
  let totaldays = moment.duration(end.diff(start)).asDays();
  for (let i = 0; i <= totaldays; i++) {
    let dat = moment(diaryStartDate).add(i, 'days').format('YYYY-MM-DD');
    if (
      !state.currentProjectDiaryEntries.find((item) => {
        return item.signedOff && item.diaryDate === dat && !item.archived;
      })
    ) {
      diaryMissingDateList.push(dat);
    }
  }

  // diaryMissingDateList.reverse();
  return diaryMissingDateList;
};

export const selectedDiaryEntry = (state) => {
  return state.selectedDiaryEntry;
};



// WEBPACK FOOTER //
// ./src/store/diaryEntry/diaryEntryGetters.js